import { parseLabelFromString } from 'contexts';
import template from './user_listing.html';

angular.module('bb.listing_search').component('userListing', {
  bindings: {
    listings: '<',
    sort: '<',
    search: '<',
    viewListing: '<',
    auth: '<',
  },
  controller: userListingController,
  controllerAs: 'vm',
  template,
});

userListingController.$inject = ['$location', '$rootScope'];
function userListingController($location, $rootScope) {
  const vm = this;

  vm.getLabel = str => str;
  $rootScope.$watch('labelOverrideMap', async () => {
    vm.getLabel = str =>
      $rootScope.labelOverrideMap[parseLabelFromString(str)]?.label ?? str;
  });

  vm.configureAppointment = function (listing) {
    if (
      listing.configured_fields &&
      listing.configured_fields['Access Instructions']
    )
      return;
    $location.path(`listing/${listing.id}/appointments/config`);
  };

  vm.viewAppointment = function (id) {
    $location.path(`listing/${id}/appointments`);
  };
}
